import { CheckOutlined, ClearOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useEffect, useState } from "react";
import type { EditFinalCellType } from "./EditFinalCellType";
import validator from "../../../../../shared/validators/filterValueValidator";
import ActionButton from "../../../../masterComponents/actionButton";
import Icon from "../../../../masterComponents/Icon";

const EditFinalCell: React.FC<EditFinalCellType> = ({
    value,
    handleSubmit,
    handleClear,
    onBlur,
    isFinalValues
}) => {

    const [curValue, setCurValue] = useState(value);

    useEffect(() => {
        setCurValue(value);
    }, [value]);

    return <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "var(--spacing-xs)" }}>
        <Input
            value={curValue}
            onChange={(e) => setCurValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !isFinalValues && handleSubmit(validator.validate(curValue))}
            onClick={(e) => e.stopPropagation()} // не активировать родителя
            autoFocus
            onBlur={onBlur}
            style={{ minWidth: 100, maxWidth: 300 }}
        />
        <ActionButton
            className="btn-color"
            icon={<Icon icon={CheckOutlined} />}
            onClick={() => handleSubmit(validator.validate(curValue))}
            onMouseDown={(e) => e.preventDefault()}
            disabled={isFinalValues}
        />
        <ActionButton
            className="btn-color"
            icon={<Icon icon={ClearOutlined} />}
            onClick={handleClear}
            onMouseDown={(e) => e.preventDefault()} //не терять фокус до клика
            disabled={!isFinalValues}
        />
    </div>
};

export default EditFinalCell;
